import React from 'react';
import styled from '@emotion/styled';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import InfoSignIcon from 'assets/svg/private-bulletin-promotion/modal-info-sign.svg';
import { useLocale } from 'locale';
import { RootAction, State } from 'store/state';
import { setPrivateBulletinHasAlreadyBeenPromotedModal, upgradeUserPlanFlow } from 'store/state/app/actions';
import {
  currentPromotionPlanIntervalHoursSelector,
  isPrivateBulletinHasAlreadyBeenPromotedModalSelector,
  makeIsBulletinBasicPromotionSelector,
  privateBulletinHasAlreadyBeenPromotedModalBulletinIdSelector,
} from 'store/state/app/private-user-monetization/selectors';
import Modal from 'ds/components/modal';
import { H3 } from 'ds/components/typography';
import { AlertModalContent } from './sharedStyled';
import { Button } from 'ds/components/button';
import { PrivateUserMonetizationSource } from 'store/state/app';

const Title = styled(H3)(({ theme }) => ({
  textAlign: 'center',
  fontWeight: 700,
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));

interface PrivateBulletinHasAlreadyBeenPromotedModalProps {
  isOpen: boolean;
  promoteHoursInterval: number;
  onClose: () => void;
  isBasicPlan?: boolean;
  bulletinId?: string | null;
  onUpgradePromotionPlanClick?: (bulletinId: string | null) => void;
}

const PrivateBulletinHasAlreadyBeenPromotedModal: React.FC<PrivateBulletinHasAlreadyBeenPromotedModalProps> = props => {
  const { isOpen, promoteHoursInterval, onClose, isBasicPlan, bulletinId, onUpgradePromotionPlanClick } = props;
  const { t } = useLocale();

  if (!isOpen) return null;

  const handleClick = () => {
    onClose();
    onUpgradePromotionPlanClick(bulletinId);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      mobileModalPositionBottom
    >
      <AlertModalContent>
        <InfoSignIcon width={88} height={88} />
        <Title>
          {t('privateBulletinPromotion.hasAlreadyBeenPromoted', { hoursInterval: promoteHoursInterval })}
        </Title>
        {isBasicPlan ? (
          <Button mode="primary" size="large" fullWidth onClick={handleClick}>
            {t('privateBulletinPromotion.seeMorePromotionsButton')}
          </Button>
        ) : null}
      </AlertModalContent>
    </Modal>
  );
};

const mapStateToProps = (state: State) => {
  const bulletinId = privateBulletinHasAlreadyBeenPromotedModalBulletinIdSelector(state);
  return {
    promoteHoursInterval: currentPromotionPlanIntervalHoursSelector(state),
    isOpen: isPrivateBulletinHasAlreadyBeenPromotedModalSelector(state),
    isBasicPlan: makeIsBulletinBasicPromotionSelector(bulletinId)(state),
    bulletinId,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  onClose: () => dispatch(setPrivateBulletinHasAlreadyBeenPromotedModal({ isOpen: false })),
  onUpgradePromotionPlanClick: (bulletinId: string | null) => dispatch(upgradeUserPlanFlow({ source: PrivateUserMonetizationSource.ListingAlreadyPromotedPopup, userInitiated: true, bulletinId })),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrivateBulletinHasAlreadyBeenPromotedModal);
